import {
    apiRequest,
    indeksProfessionalitasList,
} from "../../../../../services/adapters/kepegawaian/indeksProfessionalitas"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", indeksProfessionalitasList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository